import { render, staticRenderFns } from "./WhsE_CompanyProfile.vue?vue&type=template&id=53a9d2ea"
import script from "./WhsE_CompanyProfile.vue?vue&type=script&lang=js"
export * from "./WhsE_CompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports